// extracted by mini-css-extract-plugin
export var accountSearchResultHeader = "account-search-result-header_AyUYRSZHNOJnzH_4FkWA";
export var accountSearchResultHeaderLiveCount = "account-search-result-header__live-count_EkiXbeqJKjbpwN7URcDC";
export var accountSearchResultHeaderSeparator = "account-search-result-header__separator_gQSpHO_HiueVSloE9pkw";